<div class="container year-setup">
    <header class="row page-header">
        <div class="col-sm-12">
            <h2 class="title">PLANNING</h2>
            <p [hidden]="currentStep === 3">
                Set up a copy of your data for planning {{(selectedFiscalYear$ | async)?.yearRange}}
            </p>
        </div>
    </header>
    <div class="background-light-gray margin-top-20" [hidden]="currentStep === 3">
        <h3>Process for planning future years</h3>
        <p class="text-muted font-light">Planning is easy. You're on step {{currentStep}} of 3.</p>
        <hr />
        <div class="progressbar">
            <ul class="progress-steps">
                <li [class.active]="currentStep === 1" [class.complete]="currentStep > 1" (click)="goToStep(1)">Review anticipated expenditures</li>
                <li [class.active]="currentStep === 2" [class.complete]="currentStep > 2" (click)="goToStep(2)">Verify financial details</li>
                <li [class.active]="currentStep === 3" [class.complete]="currentStep > 3" (click)="goToStep(3)">Complete</li>
            </ul>
        </div>
    </div>

    <div>
        <div [hidden]="currentStep !== 1" class="margin-top-20">
            <sp-review-anticipated-expenditures #anticipatedExpendituresComponent
                [anticipatedExpenditures]="(anticipatedExpenditures$ | async)?.propertyComponents"
                [previousFiscalYear]="previousFiscalYear"
                [selectedYearDisplay]="(selectedFiscalYear$ | async)?.yearRange"
            ></sp-review-anticipated-expenditures>

        </div>

        <div [hidden]="currentStep !== 2">
            <sp-setup-component-aging #componentAgingComponent
                [propertyFinancial]="(property$ | async)?.propertyFinancial"
                [informationSources]="informationSources$ | async"
            ></sp-setup-component-aging>
        </div>

        <div [hidden]="currentStep !== 3">
            <div class="row justify-content-center completed-step-container">
                <div class="col-md-9">
                    <div class="text-center margin-bottom-20">
                        <i class="fa fa-check-circle large-icon"></i>
                    </div>
                    <h4 class="text-center">
                        Great, you're ready to start planning!
                    </h4>

                    <div class="completed-list font-light">
                        <p>
                            <i class="fa fa-check"></i>
                            <span>A copy of your component data has been created for planning {{(selectedFiscalYear$ | async)?.yearRange}}. This allows testing future scenarios with the ability to reset components to their current state.</span>
                        </p>
                        <p>
                            <i class="fa fa-check"></i>
                            <span>An estimation of your {{(selectedFiscalYear$ | async)?.yearRange}} financial assumptions is available.</span>
                        </p>
                    </div>

                    <div class="row margin-top-20">
                        <div class="col-md-12 text-center margin-top-20">
                            <a routerLink="/useraccount/plans" class="btn btn-lg btn-success">Start planning</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div *ngIf="hasSubmitted && (setupSaved$ | async) == 'failed'" class="row justify-content-center margin-top-20">
            <div class="col-md-8">
                <div class="alert alert-danger">
                    <i class="fa fa-exclamation-circle fa-2x margin-right-10"></i>
                    Uh oh, something went wrong! Please try submitting again.
                </div>
            </div>
        </div>


        <!-- Footer -->
        <div class="footer-section" [hidden]="currentStep === 3">
            <div class="row">
                <div class="col-md-6 margin-top-10">
                    <a class="btn btn-link btn-sm" [routerLink]="" (click)="cancel()">Cancel Setup</a>
                    <span class="vertical-line"></span>
                    <a class="btn btn-link btn-sm" [routerLink]="" (click)="onToggleAdvancedOptions()"><span>{{showAdvancedOptions ? "Hide" : "Show"}}</span> Advanced Options</a>
                </div>
                <div class="col-md-6 text-end">
                    <ng-container *ngIf="currentStep === 1">
                        <button class="btn btn-success" (click)="goToStep(2)">Continue</button>
                    </ng-container>
                    <ng-container *ngIf="currentStep === 2">
                        <button class="btn btn-success-inverted" (click)="goToStep(1)">Back to expenditures</button>
                        <button class="btn btn-success" (click)="onCompleteSetup(null)">Create a copy & start planning</button>
                    </ng-container>
                </div>
            </div>

            <div class="row" *ngIf="showAdvancedOptions" >
                <div class="col-md-6 advanced-options" >
                    <div class="text-muted font-light">ADVANCED OPTIONS</div>
                    
                    <div class="margin-top-20">
                        <a class="btn btn-link btn-sm" [routerLink]="" (click)="onSkipEverything()"><i class="fa fa-share margin-right-10"></i> <span>SKIP SETUP AND START PLANNING</span></a>
                    </div>
                </div>
            </div>
        </div>
</div>

<sp-modal title="SKIP SETUP" (confirm)="onConfirmSkipEverything()" confirmButtonText="SKIP SETUP AND START PLANNING">
    This action will create an exact copy of all components from {{previousFiscalYear?.yearRange}} without modification. The remaining useful life and cost will <b>not</b> be adjusted for inflation.
    <br/>
    <br/>
    Only choose this action if your current component data is set up for the {{(selectedFiscalYear$ | async)?.yearRange}} fiscal year.
</sp-modal>
